export { default as XSVG } from './x';
export { default as GoogleSVG } from './google';
export { default as FacebookSVG } from './facebook';
